<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<div>
    <h1>スライド調整単価登録</h1>
</div>

<!-- 詳細情報が取得できる場合表示 -->
<div *ngIf="showDetailflag">
    <form [formGroup]="slideTankatableDetailForm">
        <!-- 基本情報 -->
        <app-sgkc032d-slide-tanka-basic-info [slideadjustmentunitpriceBasicInfo]="slideadjustmentunitpriceBasicInfo"
            [mode]="displayMode" id="basicinfo"></app-sgkc032d-slide-tanka-basic-info>
        <!-- 画面モードが登録モードの場合、承認情報を表示しない。 -->
        <div *ngIf="displayMode !== 'create'">
            <app-sgkc032d-slide-tanka-approval-info [slideadjustmentunitpriceInfo]="slideadjustmentunitpriceInfo"
                [mode]="displayMode" id="approvalinfo"></app-sgkc032d-slide-tanka-approval-info>
        </div>

        <!-- 画面表示モードを入力 -->
        <app-sgkc032d-slide-tanka-tanka-info [mode]="displayMode"
            [slideadjustmentunitpriceInfo]="slideadjustmentunitpriceInfo"
            [slideadjustmentunitpriceBasicInfo]="slideadjustmentunitpriceBasicInfo"
            (onClickRegistrationEvent)="onClickRegistration()" (onClickDeleteEvent)="onClickDelete()"
            (onClickApprovalEvent)="onClickApproval()" id="tankainfo">
        </app-sgkc032d-slide-tanka-tanka-info>
    </form>

</div>